import { jsx as _jsx } from "react/jsx-runtime";
import loosePentagonUrl from '../../../assets/gems/loose_pentagon.svg?inline';
export function LoosePentagon({ ...props }) {
    return _jsx("img", { ...props, src: loosePentagonUrl, alt: 'LoosePentagonImage' });
}
